import { ReactNode } from "react";

export const MANAGED_HEAD_ATTRIBUTE = "data-interagence-head";

export type HeadNodes = ReactNode[];

export type HeadManager = {
  clear: () => void;
  upsert: (key: string, nodes: HeadNodes) => void;
};

export const createHeadManager = () => {
  const entries = new Map<string, HeadNodes>();

  return {
    entries,
    manager: {
      clear: () => entries.clear(),
      upsert: (key: string, nodes: HeadNodes) => entries.set(key, nodes),
    } satisfies HeadManager,
  };
};
